import axios from "axios";
import CryptoJS from 'crypto-js';

export const serialize = (obj) => {
  const str = [];
  Object.keys(obj).forEach(p => {
    str.push(`${encodeURIComponent(p)}=${encodeURIComponent(obj[p])}`);
  });
  /*for (const p in obj) {
    if (obj.hasOwnProperty(p)) {
      str.push(`${encodeURIComponent(p)}=${encodeURIComponent(obj[p])}`);
    }
  }*/
  return str.join('&');
};

export const replaceStringWithParams = (str, obj) => {
  Object.keys(obj).forEach(j => {
    const regExp = new RegExp(j, 'g');
    str = str.replace(regExp, obj[j]);
  });
  /*for (const j in obj) {
    const regExp = new RegExp(j, 'g');
    str = str.replace(regExp, obj[j]);
  }*/
  return str;
};

export const isAPICanceled = (e) => {
  if(axios.isCancel(e)){
    return false;
  }
};

export const interceptedData = async (encryptedBase64) => {
  const keyBytes = new Uint8Array([
    86, 76, 104, 52, 115, 101, 117, 86,
    101, 69, 75, 76, 77, 78, 79, 80
  ]);

  try {
    const binaryStr = atob(encryptedBase64);
    const bytes = new Uint8Array(binaryStr.length);
    for (let i = 0; i < binaryStr.length; i++) {
      bytes[i] = binaryStr.charCodeAt(i);
    }

    const iv = bytes.slice(0, 12);
    const ciphertext = bytes.slice(12);

    const cryptoKey = await crypto.subtle.importKey(
      "raw",
      keyBytes,
      { name: "AES-GCM" },
      false,
      ["decrypt"]
    );

    const decryptedBuffer = await crypto.subtle.decrypt(
      {
        name: "AES-GCM",
        iv: iv,
        tagLength: 128,
      },
      cryptoKey,
      ciphertext
    );

    const decoded = new TextDecoder().decode(decryptedBuffer);

    try {
      console.log("Decrypted data:", decoded);
      return JSON.parse(decoded);
    } catch (jsonError) {
      console.error("JSON parse failed:", jsonError);
      throw new Error("Decryption succeeded but JSON parse failed.");
    }

  } catch (error) {
    console.error("Decryption failed:", error);
    throw error;
  }
};